import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navLinks = [
  { path: '/', label: 'Home' },
  { path: '/product', label: 'Wolf Eye' },
  { path: '/field-tests', label: 'Field Tests' },
  { path: '/about', label: 'About' },
  { path: '/contact', label: 'Contact' }];


  const isActive = (path) => location.pathname === path;

  return (
    <header className="dark-header">
      <Link to="/" className="logo-container" style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
        <img
          src="https://customer-assets.emergentagent.com/job_wolf-eye/artifacts/128p77ad_LABANA%20Gold%20NO%20TEXT%2C%20TRANSPARENT%20-%20Copy.png"
          alt="Labana Dynamics"
          className="dark-logo" />

        <span style={{ fontSize: '18px', fontWeight: '700', color: '#D4AF37', letterSpacing: '0.5px', position: 'relative', top: '6px' }} className="!font-mono !font-extralight !italic !text-[#D4AF37]">LABANA DYNAMICS OÜ</span>
      </Link>

      <nav className="dark-nav desktop-nav">
        {navLinks.map((link) =>
        <Link
          key={link.path}
          to={link.path}
          className={`dark-nav-link ${isActive(link.path) ? 'active' : ''}`}>

            {link.label}
          </Link>
        )}
        <Link to="/contact" className="btn-primary" style={{ marginLeft: '20px' }}>
          Request Quote
        </Link>
      </nav>

      <button
        className="mobile-menu-btn"
        onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        aria-label="Toggle menu">

        {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
      </button>

      {mobileMenuOpen &&
      <nav className="mobile-nav">
          {navLinks.map((link) =>
        <Link
          key={link.path}
          to={link.path}
          className={`dark-nav-link ${isActive(link.path) ? 'active' : ''}`}
          onClick={() => setMobileMenuOpen(false)}>

              {link.label}
            </Link>
        )}
          <Link
          to="/contact"
          className="btn-primary"
          onClick={() => setMobileMenuOpen(false)}>

            Request Quote
          </Link>
        </nav>
      }
    </header>);

};

export default Header;